/** TEMU「商品层级」列：每一导出组首行 spu，其余行 sku（与官方批量模板一致） */

export function isTemuProductLevelHeaderName(templateHeaderName) {
  const name = String(templateHeaderName || '').trim();
  return (
    name === '商品层级'
    || name.includes('商品层级')
    || name === '商品层级：商品层级'
    || name.includes('商品层级：')
  );
}

export function resolveTemuProductLevelByGroupRowIndex(rowIndexInGroup) {
  return Number(rowIndexInGroup) === 0 ? 'spu' : 'sku';
}
